module.exports = __webpack_public_path__ + "static/img/nianhuo@2x.99a75caf.png";